<template>
  <div class="oneui">
    <div
      class="center-div"
      style="position: fixed; width: 100vw; height: var(--top-padding)"
    >
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{ $root.$data.kids[Number(child)].get("name") }}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div id="choreContainer" class="kidsHome cardContainer">
          <reward
            :reward="$root.$data.kids[Number(child)].get('customReward')"
            :class="`${$root.parent.get('slimView') ? 'card-slim' : ''}`"
            mode="kids"
            :updater="$root"
            :kid="$root.$data.kids[Number(child)]"
          />
          <div class="card allDone" v-show="isDone">
            <h3>{{ $t("pages.kids.goodJob") }}</h3>
            <p>{{ $t("pages.kids.done") }}</p>
          </div>
          <chore
            v-for="chore in $root.$data.chores[Number(child)].filter(
              (_chore) => !_chore.get('done')
            )"
            :key="chore.id"
            :kid="$root.$data.kids[Number(child)]"
            :chore="chore"
            mode="kids"
            @click.native="done(chore, 'chores')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reward from "@/components/Reward";
import Chore from "@/components/Chore";

export default {
  components: {
    Reward,
    Chore,
  },
  data() {
    return {
      isDone: false,
      child: null,
    };
  },
  methods: {
    async done(chore) {
      let confirm = await ModernModals.prompt(
        this.$t("pages.kids.confirmChore"),
        `Did you finish ${chore.get("name")}?`
      );
      if (confirm) {
        this.$router.push({
          path: "/kids/action/done/",
          query: {
            kid: this.$route.query.ind,
            chore: chore.id,
          },
        });
      }
    },
  },
  mounted() {
    this.$root.$data.locked = true;
    this.$data.child = this.$route.query.ind;
    this.$data.isDone =
      this.$root.$data.chores[Number(this.$data.child)].filter(
        (_chore) => !_chore.get("done")
      ).length == 0;
  },
};
</script>